import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { DeepLinkSearchParams } from '@server/deep-link-search-params';

const replaceUrlSearchMap = {
  forceAutomationId: DeepLinkSearchParams.automationId,
  forceVersionId: DeepLinkSearchParams.versionId,
  forceRollupId: DeepLinkSearchParams.rollupId,
};

// This is a temporary function to redirect legacy query params to the new ones
// We can remove this after 6 months. Remove it in October 2025
export const useRedirectLegacyQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    Object.entries(replaceUrlSearchMap).forEach(([legacy, newParamName]) => {
      if (searchParams.get(legacy)) {
        searchParams.set(newParamName, searchParams.get(legacy) as string);
        searchParams.delete(legacy);
      }
    });
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
